<template>
      <div class="tile">
        <div class="tile__title">
          <slot name="header"></slot>
        </div>
        <div class="tile__description">
          <slot name="content"></slot>
        </div>
        <slot name="footer"></slot>
      </div>
</template>

<script>

export default {
    name: 'Tile'
}
</script>
